<script>
import moment from 'moment'
import { Bar } from 'vue-chartjs'

export default {
  name: 'InspLoadAppChart',
  extends: Bar,

  components: {},

  props: {
    items: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: false,
      default: '',
    },
    companyName: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      data: {},
      options: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          fontSize: '24',
          text: this.$t('ELE0306'),
        },
        layout: {
          padding: {
            top: 10,
            bottom: 10,
            left: 0,
            right: 0,
          },
        },
        scales: {
          xAxes: [
            {
              display: true,
              ticks: {
                autoSkip: true,
                autoSkipPadding: 0,
                display: true,
                minRotation: 90,
                crossAlign: 'far',
                padding: 5,
              },
              gridLines: {
                drawOnChartArea: false,
                drawTicks: false,
              },
              stacked: true,
            },
          ],
        },
        legend: {
          display: true,
          position: 'bottom',
        },
        tooltips: {
          mode: 'nearest',
          intersect: false,
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
      },
    }
  },
  methods: {
    setItems() {
      let data = {
        datasets: [],
        labels: [],
        tooltips: [],
      }

      let outstandingApp = {
        label: this.$t('ELE0302'),
        type: 'line',
        borderColor: '#8c1429',
        pointBackgroundColor: '#8c1429',
        backgroundColor: 'transparent',
        lineTension: 0,
        fill: true,
        data: [],
      }
      let capaAppNormal = {
        label: this.$t('ELE0112'),
        type: 'line',
        borderColor: '#23BB68',
        pointBackgroundColor: '#23BB68',
        backgroundColor: 'transparent',
        borderDash: [10],
        pointRadius: 0,
        lineTension: 0,
        fill: true,
        data: [],
      }
      let capaAppOt = {
        label: this.$t('ELE0113'),
        type: 'line',
        borderColor: 'red',
        pointBackgroundColor: 'red',
        backgroundColor: 'transparent',
        borderDash: [10],
        pointRadius: 0,
        lineTension: 0,
        fill: true,
        data: [],
      }
      let totalAppLot = {
        label: this.$t('ELE0303'),
        type: 'bar',
        stack: 'Stack',
        backgroundColor: '#70b2ff',
        data: [],
      }

      this.items.forEach((item) => {
        capaAppNormal.data.push(item.capaAppNormal ?? 0)
        capaAppOt.data.push(item.capaAppOt ?? 0)
        totalAppLot.data.push(item.totalAppLot ?? 0)
        outstandingApp.data.push(item.outstandingApp ?? 0)
        data.labels.push(moment(item.date).format('Do MMM'))
      })

      data.datasets = [capaAppNormal, capaAppOt, outstandingApp, totalAppLot]

      this.options.title.text = `${this.$t('ELE0306')} APP ${this.name} ${
        this.companyName ? '( IQC ' + this.companyName + ')' : ''
      }`
      this.data = data
    },
    async displayChart() {
      await this.setItems()
      this.renderChart(this.data, this.options)
    },
  },
  mounted() {
    this.displayChart()
  },
  watch: {
    items: {
      handler: function () {
        this.displayChart()
      },
      deep: true,
    },
  },
}
</script>
